module.exports = __webpack_public_path__ + "media/fonts/Oricons-5136e11f158bb06ee9814158ef22dcfb.woff";